import { useEffect, useState } from 'react';
import axios from 'src/axios';

/**
 * Display names ("First Last") of the staff members who can be credited on a
 * clinical record — the option list behind every "Recorded By" autocomplete.
 *
 * Shared so the diagnoses, phenotypes and genotypes editors offer the same
 * list: the genotype editor used to render its autocomplete with no options at
 * all, which for a role without free-text rights (see `canCreate` in
 * AutocompleteInput) made the field impossible to change.
 */
export const useStaffMemberNames = () => {
  const [staffMemberNames, setStaffMemberNames] = useState([]);

  useEffect(() => {
    let cancelled = false;

    axios
      .get('/clinical-notes/staff-members')
      .then((res) => {
        if (cancelled) return;
        const names = (res.data || []).map((m) =>
          `${m.firstName || ''} ${m.lastName || ''}`.trim()
        );
        // Two staff sharing a name would otherwise appear twice with nothing
        // to tell them apart; the field stores the name, not the id.
        setStaffMemberNames([...new Set(names.filter(Boolean))]);
      })
      .catch(() => {
        // Non-fatal: the field falls back to whatever the record already has.
        if (!cancelled) setStaffMemberNames([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return staffMemberNames;
};

export default useStaffMemberNames;
